import React from 'react';
import * as moment from 'moment';
import { Form, Input, DatePicker, Select, Checkbox, Radio } from 'antd';
import FieldFileInput from './FileInput';

const Option = Select.Option;
const { TextArea } = Input;
const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

export const required = value => (value ? undefined || value === 0 || value === null || value === '' : 'Bitte füllen Sie dieses Feld aus!');
export const requiredWithZero = value => { if(value === undefined || value.toString().length === 0) { return 'Bitte füllen Sie dieses Feld aus!' } };
export const maxLength = max => value => (value && value.length > max ? `Maximal ${max} Zeichen` : undefined);
export const maxLength15 = maxLength(15);
export const minLength = min => value => (value && value.length < min ? `Mindestens ${min} Zeichen` : undefined);

export const minLength2 = minLength(2);
export const minLength8 = minLength(8);
export const number = value => (value && isNaN(Number(value)) ? 'Bitte geben Sie nur Zahlen ein' : undefined);
export const minValue = min => value => (value && value < min ? `Mindestens ${min}` : undefined);
export const email = value => (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Ungültige E-Mail Adresse' : undefined);
export const alphaNumeric = value => (value && /[^a-zA-Z0-9 ]/i.test(value) ? 'Keine Sonderzeichen erlaubt' : undefined);
/*export const phoneNumber = value => (value && !/^(0|[1-9][0-9]{9})$/i.test(value) ? 'Ungültige Telefonnummer' : undefined);*/
export const phoneNumber = value => (value && !/[0-9]*\/*(\+49)*[ ]*(\([0-9]+\))*([ ]*(-|–)*[ ]*[0-9]+)*/i.test(value) ? 'Ungültige Telefonnummer' : undefined);



export const validMomentTime = value => (value && value === '-1' && !moment(value).isValid() ? 'Bitte geben Sie eine gültige Zeit an.' : undefined);

export const requiredDayPicker = value => (value ? undefined || value === [] || value.length === 0 : 'Bitte wählen Sie mindestens einen Tag aus!');

//<label htmlFor={input.name} className={` ${active && 'visible'}`}>{label}</label>


const formCheckboxLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 12 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
    },
};

const formCheckboxRechtlichLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
};


export const renderField = ({
                                input,
                                label,
                                type,
                                required,
                                meta: { active, touched, error, warning }
                            }) => (
    <FormItem
        label={label}
        hasFeedback
        required={required}
        validateStatus={touched && error ? 'error' : ''}
    >
        <Input {...input} />


    </FormItem>
);


export const renderDatebox = ({
                                input,
                                label,
                                type,
                                required,
                                meta: { active, touched, error, warning }
                            }) => (
    <FormItem

        label={label}
        hasFeedback
        required={required}
        validateStatus={touched && error ? 'error' : ''}
    >
        <DatePicker {...input} value={input.value === '' ? undefined : moment(input.value)} />


    </FormItem>
);

export const renderTextarea = ({
                                  input,
                                  label,
                                  type,
                                  max,
                                  required,
                                  meta: { active, touched, error, warning }
                              }) => (
    <FormItem
        label={label}
        hasFeedback
        required={required}
        validateStatus={touched && error ? 'error' : ''}
    >
        <TextArea {...input} rows={9} maxlength={max} />


    </FormItem>
);


/*
export const renderCheckbox = ({
                                   input,
                                   label,
                                   type,
                                   max,
                                   meta: { active, touched, error, warning }
                               }) => (
    <FormItem

        label={label}
        hasFeedback
        validateStatus={touched && error ? 'error' : ''}
    >
        <input {...input} type={"checkbox"} checked={input.value} />


</FormItem>
);
 */

export const renderCheckbox = ({
                                   input,
                                   label,
                                   type,
                                   required,
                                   meta: { active, touched, error, warning }
                               }) => (
    <FormItem

        hasFeedback
        required={required}
        validateStatus={touched && error ? 'error' : ''}
    >
        <Checkbox defaultChecked={input.value} onChange={(value) => { input.onChange(value)}}>{label}</Checkbox>


    </FormItem>
);



export const renderFileField = ({
                                input,
                                label,
                                type,
                                required,
                                meta: { active, touched, error, warning }
                            }) => (
    <FormItem
        label={label}
        hasFeedback
        required={required}
        validateStatus={touched && error ? 'error' : ''}
    >
        <FieldFileInput input={input} />


    </FormItem>
);


export const renderSelectField = ({
                                            input,
                                            label,
                                            required,
                                            options,
                                            onCH,
                                            meta: { active, touched, error, warning }
                                        }) => (
    <FormItem
        label={label}
        hasFeedback
        required={required}
        validateStatus={touched && error ? 'error' : ''}

    >
        <Select {...input} onChange={(value) => {input.onChange(value); if(onCH) {onCH(value);}}}>
        {options.map(option =>
            <Option
                value={option.ID}>
                {option.Name}
            </Option>)
        }
        </Select>
    </FormItem>
);


export const renderRadioField = ({
                                      input,
                                      label,
                                      required,
                                      options,
                                      meta: { active, touched, error, warning }
                                  }) => (
    <FormItem
        label={label}
        hasFeedback
        required={required}
        validateStatus={touched && error ? 'error' : ''}

    >
        <RadioGroup {...input} >
            {options.map(radio =>
                <Radio
                    value={radio.ID}
                    key={radio.ID}>
                    {radio.Name}
                </Radio>)
            }
        </RadioGroup>
    </FormItem>
);


// WEBPACK FOOTER //
// ./src/components/FormValidation.js